var _defs, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_14_3",
    "data-name": "Component 14 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 45,
    cy: 45,
    r: 45,
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(8 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(74 50)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(0 67)",
    fill: "url(#linear-gradient)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M16.656-34.594a2.562,2.562,0,0,0-2.562,2.563V-26.1A17.307,17.307,0,0,0,0-33.312,17.314,17.314,0,0,0-16.53-21.285a2.561,2.561,0,0,0,1.65,3.226,2.558,2.558,0,0,0,3.227-1.649A12.2,12.2,0,0,1,0-28.187a12.209,12.209,0,0,1,9.962,5.125H6.406A2.562,2.562,0,0,0,3.844-20.5a2.562,2.562,0,0,0,2.563,2.563h10.25A2.562,2.562,0,0,0,19.219-20.5V-32.031A2.56,2.56,0,0,0,16.656-34.594ZM14.879-12.684a2.561,2.561,0,0,0-3.227,1.649A12.2,12.2,0,0,1,0-2.562,12.21,12.21,0,0,1-9.962-7.687h3.555A2.562,2.562,0,0,0-3.844-10.25a2.562,2.562,0,0,0-2.562-2.562h-10.25a2.562,2.562,0,0,0-2.562,2.563V1.281a2.562,2.562,0,0,0,2.563,2.563,2.562,2.562,0,0,0,2.563-2.562V-4.652A17.269,17.269,0,0,0-.072,2.563,17.315,17.315,0,0,0,16.456-9.465,2.432,2.432,0,0,0,14.879-12.684Z",
    transform: "translate(45.219 55.912)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateTime);
export default __webpack_public_path__ + "static/media/updateTime.e3c9c756404a0976d32c6fc87a88df1b.svg";
export { ForwardRef as ReactComponent };